module.exports = __webpack_public_path__ + "img/1a3e676.png";